import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { ClinicContext } from "../../Context/ClinicContext";
import css from "../TerAct/TerAct.module.css";
import { Head } from "../../Utils/Head";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { valuesQuestionarePt } from "../../Utils/valuesQuestionare";
import { Input } from "../Forms/Input";
import { newId } from "../../Utils/newId";

export const NewAct = () => {
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const [newAct, setNewAct] = useState("");
  const [selectedValue, setSelectedValue] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().add(1, "day").format("YYMMDD")
  );
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");
  const [value3, setValue3] = useState("");
  const [value4, setValue4] = useState("");
  const [value5, setValue5] = useState("");
  const [value6, setValue6] = useState("");
  const navigate = useNavigate();
  const lastStep = 3;

  useEffect(() => {
    const valuesScores = userData ? [...userData.listValues] : [];

    const valuesNames = [
      {
        name: valuesQuestionarePt[0].value,
        score: valuesScores[0],
      },
      { name: valuesQuestionarePt[1].value, score: valuesScores[1] },
      { name: valuesQuestionarePt[2].value, score: valuesScores[2] },
      { name: valuesQuestionarePt[3].value, score: valuesScores[3] },
      { name: valuesQuestionarePt[4].value, score: valuesScores[4] },
      { name: valuesQuestionarePt[5].value, score: valuesScores[5] },
    ];

    valuesNames.sort((a, b) => b.score - a.score);

    setSelectedValue(valuesNames[0].name);
    setValue1(valuesNames[0].name);
    setValue2(valuesNames[1].name);
    setValue3(valuesNames[2].name);
    setValue4(valuesNames[3].name);
    setValue5(valuesNames[4].name);
    setValue6(valuesNames[5].name);
  }, [userData]);

  function handleTimeByDay(day) {
    const dayPor = dayjs(day).format("ddd");
    switch (dayPor) {
      case "Sun":
        return "Dom";
      case "Mon":
        return "Seg";
      case "Tue":
        return "Ter";
      case "Wed":
        return "Qua";
      case "Thu":
        return "Qui";
      case "Fri":
        return "Sex";
      case "Sat":
        return "Sáb";
      default:
        return;
    }
  }

  const finish = () => {
    const obj = {
      id: newId(),
      value: selectedValue,
      act: newAct,
      mood: "",
      done: false,
      date: selectedDate,
    };

    if (!userData.diary) {
      userData.diary = {};
      userData.diary[selectedDate] = [obj];
    } else if (userData.diary[selectedDate]) {
      userData.diary[selectedDate].push(obj);
    } else {
      userData.diary[selectedDate] = [obj];
    }

    setUserData(userData);
    setNewAct("");
    setSelectedDate(dayjs().add(1, "day").format("YYMMDD"));
    setSelectedValue(value1);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/schedule");
  };

  return (
    <div className={css.container}>
      <Head
        title="JourneyIntroduction"
        description={"SufferingAxis - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            setNewAct("");
            setSelectedDate(dayjs().add(1, "day").format("YYMMDD"));
            setSelectedValue(value1);
            navigate("/schedule");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((lastStep - step) * 100) / lastStep}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <>
            <h1>Escolha uma direção</h1>
            <div>
              <label className={css.confirmation}>
                <p>{value1}</p>
                <input
                  type="checkbox"
                  checked={selectedValue === value1 ? true : false}
                  onChange={() => {
                    setSelectedValue(value1);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>{value2}</p>
                <input
                  type="checkbox"
                  checked={selectedValue === value2 ? true : false}
                  onChange={() => {
                    setSelectedValue(value2);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>{value3}</p>
                <input
                  type="checkbox"
                  checked={selectedValue === value3 ? true : false}
                  onChange={() => {
                    setSelectedValue(value3);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
            </div>
            <div className={css.myValues}>
              <label className={css.confirmation}>
                <p>{value4}</p>
                <input
                  type="checkbox"
                  checked={selectedValue === value4 ? true : false}
                  onChange={() => {
                    setSelectedValue(value4);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>{value5}</p>
                <input
                  type="checkbox"
                  checked={selectedValue === value5 ? true : false}
                  onChange={() => {
                    setSelectedValue(value5);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>{value6}</p>
                <input
                  type="checkbox"
                  checked={selectedValue === value6 ? true : false}
                  onChange={() => {
                    setSelectedValue(value6);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
            </div>
          </>
        )}
        {step === 1 && (
          <>
            <h1>Valor: {selectedValue}</h1>
            <p>Transforme esse valor em ação:</p>
            <Input
              type="text"
              name="newAct"
              placeholder={"Descreva a ação a ser feita..."}
              value={newAct}
              onChange={(e) => setNewAct(e.target.value)}
              autoComplete="off"
              maxLength="100"
            />
            {/* <p>Sugestões Personalizadas:</p>
            <p>[Valor]</p>
            <p>[Temperamento 1]: </p>
            <p>[Temperamento 2]: </p>
            <p>[Temperamento 3]: </p> */}
          </>
        )}
        {step === 2 && (
          <>
            <h1>Escolha uma data</h1>
            <div className={css.myValues}>
              <label className={css.confirmation}>
                <p>Hoje {dayjs().format("DD/MM/YY")}</p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().format("YYMMDD") ? true : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>
                  {handleTimeByDay(dayjs().add(1, "day")) +
                    " " +
                    dayjs().add(1, "day").format("DD/MM/YY")}
                </p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().add(1, "day").format("YYMMDD")
                      ? true
                      : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().add(1, "day").format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>
                  {handleTimeByDay(dayjs().add(2, "day")) +
                    " " +
                    dayjs().add(2, "day").format("DD/MM/YY")}
                </p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().add(2, "day").format("YYMMDD")
                      ? true
                      : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().add(2, "day").format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>
                  {handleTimeByDay(dayjs().add(3, "day")) +
                    " " +
                    dayjs().add(3, "day").format("DD/MM/YY")}
                </p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().add(3, "day").format("YYMMDD")
                      ? true
                      : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().add(3, "day").format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>
                  {handleTimeByDay(dayjs().add(4, "day")) +
                    " " +
                    dayjs().add(4, "day").format("DD/MM/YY")}
                </p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().add(4, "day").format("YYMMDD")
                      ? true
                      : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().add(4, "day").format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>
                  {handleTimeByDay(dayjs().add(5, "day")) +
                    " " +
                    dayjs().add(5, "day").format("DD/MM/YY")}
                </p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().add(5, "day").format("YYMMDD")
                      ? true
                      : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().add(5, "day").format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
              <label className={css.confirmation}>
                <p>
                  {handleTimeByDay(dayjs().add(6, "day")) +
                    " " +
                    dayjs().add(6, "day").format("DD/MM/YY")}
                </p>
                <input
                  type="checkbox"
                  checked={
                    selectedDate === dayjs().add(6, "day").format("YYMMDD")
                      ? true
                      : false
                  }
                  onChange={() => {
                    setSelectedDate(dayjs().add(6, "day").format("YYMMDD"));
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
            </div>
          </>
        )}
        {step === 3 && (
          <>
            <h1>Resumo</h1>
            <p>Direção: {selectedValue}</p>
            <p>Ação: {newAct}</p>
            <p>
              Dia: {selectedDate.slice(4, 6)}/{selectedDate.slice(2, 4)}/
              {selectedDate.slice(0, 2)}
            </p>
          </>
        )}
      </section>
      <div>
        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === 1 && !newAct[3] ? (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Próximo
            </button>
          ) : step === lastStep ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Criar Nova Ação
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
